<script setup>
import { onMounted, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { useFunctionGetter, useStore } from 'dashboard/composables/store';

import WootReports from './components/WootReports.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

const { t } = useI18n();
const route = useRoute();
const store = useStore();
const agent = useFunctionGetter('agents/getAgentById', route.params.id);

const reportTitle = computed(
  () => agent.value?.name || t('AGENT_REPORTS.HEADER')
);

onMounted(() => store.dispatch('agents/get'));
</script>

<template>
  <WootReports
    v-if="agent.id"
    :key="agent.id"
    type="agent"
    getter-key="agents/getAgents"
    action-key="agents/get"
    header-icon="i-lucide-user"
    header-accent="slate"
    back-route="agent_reports_index"
    :selected-item="agent"
    :download-button-label="$t('AGENT_REPORTS.DOWNLOAD_AGENT_REPORTS')"
    :report-title="reportTitle"
    :report-subtitle="$t('AGENT_REPORTS.DESCRIPTION')"
  />
  <div v-else class="w-full py-20">
    <Spinner class="mx-auto" />
  </div>
</template>
